import {Component, effect, inject, model} from '@angular/core';
import {IApiRow, ITableAction, SharedGridOptions, TableControlComponent, TableControlModule} from 'frontier/browserkit';
import {EControlActions, EsvgFiles, INITIAL_STATE_TOKEN} from 'frontier/nucleus';
import {filter, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {ThemePalette} from '@angular/material/core';
import {ProcessOverviewStore} from '../../../service/process-overview.store';
import AppControlGuids from '../../../../../../api/ControlGuids';

@Component({
  selector: 'app-dunning-info',
  templateUrl: '../../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrls: [
    '../../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss'
  ],
  standalone: true,
  imports: [TableControlModule],
  providers: [
    {provide: INITIAL_STATE_TOKEN, useValue: {filter: null}},
    {provide: TableControlComponent, useExisting: DunningInfoComponent},
  ],
})
export class DunningInfoComponent extends TableControlComponent {
  private _processOverviewService = inject(ProcessOverviewStore);
  readonly selectedCart = this._processOverviewService.selectedCart;

  override GUID = AppControlGuids.TDunningInfo;
  override actions = model<ITableAction[]>([
    {
      displayName: 'Mahnung herunterladen',
      controlAction: EControlActions.import,
      disabledIfNoSelection: true,
      disabledIfMultiSelection: true,
      color: 'accent' as ThemePalette,
      icon: EsvgFiles.download,
      action: () => this.downloadDunningDocument(),
    }
  ]);
  override gridOptions = {
    ...SharedGridOptions
  }

  constructor() {
    super();

    effect(() => {
      const selectedCart = this.selectedCart();
      if (selectedCart) {
        this.patchFilter({
          parent: selectedCart.obj,
          typename: 'cart',
        })
      }
    }, {allowSignalWrites: true});

    this.subs.add(
      this.controlStore.controlDataChanged$.pipe(
        filter(evt => {
          return new Map([
            [AppControlGuids.TCartList, new Set([EControlActions.dunning])],
            [AppControlGuids.TOpenItemList, new Set([EControlActions.dunning])],
          ]).get(evt.GUID)?.has(evt.changeType);
        }),
        tap(() => {
          // The open items table should change and fetch if an invoice was canceled.
          this.refreshInfiniteCache();
        })).subscribe(),
    );
  }

  private downloadDunningDocument(): Observable<any> {
    const selectedRowObj: IApiRow = this.selectedRows()[0].apiRow;
    const cell = selectedRowObj.cols[selectedRowObj.cols.length - 1];
    if (!cell?.value) {
      return of(null);
    }
    const documentType = cell.value.type;
    return this.controlService.controlGetDownloadDocument(
      this.instanceId(),
      cell.value.rowid.toString(),
      documentType,
      cell.value.signature,
    ).pipe(
      tap((data) => {
        if (data) {
          const downloadURL = window.URL.createObjectURL(data as Blob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = selectedRowObj.obj.name || this.selectedRows()[0][0].value;
          link.click();
        }
      })
    )
  }
}
